import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Modal, Progress,
} from 'reactstrap';

function InternalOrderProgressModal(props) {
  const {
    shown, order, onClose, t,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [shown, order]);

  if (order == null) return null;

  const renderRows = () => order.items.map((item) => {
    const picked = item.pick_items
      ? item.pick_items.reduce((a, pi) => a + pi.picked_qty + (pi.void * pi.qty), 0)
      : 0;
    const pct = item.qty === 0 ? 0 : (picked / item.qty) * 100;
    const label = item.inventory !== null
      ? item.inventory.part_number
      : `KIT-${item.stock_id}`;

    const itemId = item.kit?.id || item.inventory?.id || null;
    const urlBase = item.kit !== null ? `/kits/${itemId}` : `/inventory/${itemId}`;

    return (
      <tr key={item.id}>
        <td>
          {item.stock_id}
        </td>
        <td>
          {item.kit !== null ? (
            <a
              href={urlBase}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </a>
          ) : (
            label
          )}
        </td>
        <td>{`${picked}/${item.qty}`}</td>
        <td>
          <Progress value={pct} animated striped={pct !== 100} color={pct === 100 ? 'success' : 'info'} />
        </td>
      </tr>
    );
  });

  return (
    <Modal size="md" isOpen={modalOpen}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">{t('Picked Progress')}</h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => { setModalOpen(false); onClose(); }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body table-responsive">
        <table className="table table-bordered table-striped mb-0">
          <thead>
            <tr>
              <th>{t('Stock ID')}</th>
              <th>{t('Item')}</th>
              <th>{t('Picked')}</th>
              <th>{t('Progress')}</th>
            </tr>
          </thead>
          <tbody>
            {renderRows()}
          </tbody>
        </table>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-soft-dark"
          data-dismiss="modal"
          onClick={() => { setModalOpen(false); onClose(); }}
        >
          {t('Close')}
        </button>
      </div>
    </Modal>
  );
}

InternalOrderProgressModal.defaultProps = {
  t: null,
  shown: false,
  order: null,
  onClose: () => {},
};

InternalOrderProgressModal.propTypes = {
  t: PropTypes.any,
  shown: PropTypes.bool,
  order: PropTypes.object,
  onClose: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(InternalOrderProgressModal));
